import React from 'react';
import { Main } from './components';

export const Entries: React.FC = () => {
  return <Main />;
};

